import { useGetCurrentUserProfileQuery } from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import { UserRead } from 'app/store/reducers/api/config-manager-cloud-services/store/types';

/** Effective permission strings for the user's currently-active account. */
export const useCurrentAccountPermissions = (): string[] => {
  const { data: profile = {} as UserRead } = useGetCurrentUserProfileQuery();
  const current = profile.currentAccount;
  if (!current || !profile.accounts) return [];
  const account = profile.accounts.find(a => a.accountId === current);
  return account?.permissions ?? [];
};

/** True if the active account grants `permission`. */
export const usePermission = (permission: string): boolean => {
  const permissions = useCurrentAccountPermissions();
  return permissions.includes(permission);
};

/** True if the active account grants ANY of the given permissions. */
export const useHasAnyPermission = (permissions: string[]): boolean => {
  const granted = useCurrentAccountPermissions();
  return permissions.some(p => granted.includes(p));
};
